import { createGlobalStyle, ThemeProvider } from 'styled-components';

export const ResetStyle = createGlobalStyle`
  * {
    &, &::before, &::after {
      box-sizing: border-box;
    }
  }

  html, body {
    border: 0;
    margin: 0;
    padding: 0;
    transition: none;
  }

  div, span, object, iframe, img, article, aside, canvas, details, figure, hgroup, menu, nav, footer, header, section, summary, mark, audio, video {
    border: 0;
    margin: 0;
    padding: 0;
  }

  svg {

    &, * {
      transition: none;
    }
  }

  h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, address, cit, code,
  del, dfn, em, ins, q, samp, small, strong, sub, sup, b, i, hr, dl, dt, dd,
  ol, ul, li, fieldset, legend, label {
    border: 0;
    font-size: 100%;
    vertical-align: baseline;
    margin: 0;
    padding: 0;
  }

  ul {
    list-style: none;
  }

  article, aside, canvas, figure, figure img, figcaption, hgroup,
  footer, header, nav, section, audio, video {
    display: block;
  }

  input, textarea, button, select {
    background: inherit;
    border: 0;
    outline: none;
    font-family: inherit;
    vertical-align: top;
  }

  select {
    appearance: select;
  }

  button:focus {
    outline: none;
  }
`;

export const GeneralStyle = createGlobalStyle`
  html {
    font-size: ${props => props.theme.remSize};
    line-height: ${props => props.theme.lineHeight[3]};
  }

  body {
    background: ${props => props.theme.colors.bodyBackground};
    color: ${props => props.theme.colors.bodyText};
    font-size: ${props => props.theme.fontSize[3]};
  }

  ::selection {
    background: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.white};
  }
`;

export default ThemeProvider;
